window.goTopComponent = {
    goTop: function () {
        $('html,body').animate({scrollTop: 0}, 1200);
    },

    watchScroll: function () {
        goTopComponent.checkScroll();
        $(window).scroll(goTopComponent.checkScroll);
    },
    checkScroll: function () {
        if ($(window).scrollTop() > 400) {
            $('#goTop').fadeIn('fast');
            $('#goTopButton').fadeIn('fast');
        } else { 
            $('#goTop').fadeOut('fast');
            $('#goTopButton').fadeOut('fast');
        }
    },
    goDown: (on) => {

        if (on) {
            $('html, body').animate({
                scrollTop: $("#markbegins").offset().top - 55
            }, 2000);
        }
    },
};

goTopComponent.watchScroll();
document.getElementById("goTop").onclick = function () {
    goTopComponent.goTop();
    return false;
};

if(document.getElementById("goTopButton")){
    document.getElementById("goTopButton").onclick = function () {
        goTopComponent.goTop();
        return false;
    };
}
$('#startHere').click(() => {
    goTopComponent.goDown(true)
});
